export default (props) => (
  <svg {...props} viewBox="0 0 30 30" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h30v30H0z" />
      <path
        d="M15 4c4.556 0 7.5 3.152 7.5 7.04 0 3.13-4.598 10.901-6.682 13.811-.38.532-1.254.532-1.635 0C12.098 21.941 7.5 14.17 7.5 11.04 7.5 7.152 10.444 4 15 4zm0 3.75A3.125 3.125 0 1015 14a3.125 3.125 0 000-6.25z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
